export default __webpack_public_path__ + "static/media/politicasustentabilidade2.1ebdda02.png";